import {startCase} from "lodash";
import {Playshot} from "../../model/Playshot";

export const getService = (nodeData: object & {service?: string}, playshot: Playshot): string => {
  return nodeData.service || getDefaultService(playshot);
}

export const nodeLabel = (fqcn: string): string => {
  const lastPart = fqcn.split(".").pop();

  return startCase(lastPart || '');
}

export const nodeService = (fqcn: string): string => {
  const firstPart = fqcn.split(".").shift();

  return firstPart || 'App';
}

export const getDefaultService = (playshot: Playshot): string => {
  return playshot.playConfig.defaultService || 'App';
}

export const removeDefaultService = (fqcn: string, playshotOrDefaultService: string | Playshot): string => {
  if(typeof playshotOrDefaultService !== "string") {
    playshotOrDefaultService = playshotOrDefaultService.playConfig.defaultService;
  }

  const parts = fqcn.split(".");

  if(parts.length && parts[0] === playshotOrDefaultService) {
    parts.shift();
  }

  return parts.join(".");
}
